import { app } from '../../../../app';
import { Controller } from './authentication-policies.controller';

app.component('companyManageApplicationAuthenticationPolicies', {
    bindings: {
        application: '<',
        companyId: '<',
        currentPasswordAuthenticationSettings: '<',
        authenticationAccessPolicyList: '<',
    },
    controller: Controller,
    templateUrl: require('./authentication-policies.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/authentication-policies/authentication-policies.component.js